import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { DropdownList } from '../../common/components/formControls';
import { loadParents, fetchParent } from './actions';

class ParentsDropdownList extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.handleSearchTermChange = this.handleSearchTermChange.bind(this);

		this.state = {
			searchTerm: '',
			selectedId: null
		};
	}

	componentDidMount() {
		this.searchParents('');
	}

	searchParents(searchTerm) {
		this.props.loadParents({ sortKey: 'id', sortDirection: 'asc', pageNumber: 1, pageSize: 20, name: searchTerm });
	}

	handleSelectChange(parentId) {
		this.setState({ selectedId: parentId });

		const { fetchParent, onChange } = this.props;

		if (parentId) {
			const { data } = this.getFilteredData();

			if (!data.find(x => x.id === parentId)) {
				fetchParent(parentId);
			}
		}

		if (onChange) {
			onChange(parentId);
		}
	}

	handleSearchTermChange(searchTerm) {
		this.setState({ searchTerm });
		this.searchParents(searchTerm);
	}

	getFilteredData() {
		const parentsFilter = this.props.parentsBySearchTerm[this.state.searchTerm] || { ids: [], loading: false };
		const data = parentsFilter.ids.map(id => this.props.parents[id]);

		if (!parentsFilter.ids.find(x => x === this.state.selectedId)) {
			const selectedParent = this.props.parents[this.state.selectedId];
			if (selectedParent) {
				data.push(selectedParent);
			}
		}

		return { data, loading: parentsFilter.loading };
	}

	renderListItem({ item }) {
		return <div>
			<div style={{ fontWeight: 'bold' }}>{item.fullName}</div>
			<div>{item.email}</div>
			<div>{item.city}</div>
		</div>;
	}

	renderSelectedItem({ item }){
		return <span>{item.fullName}</span>;
	}

	render() {
		const { name = 'parentId', parents, parentsBySearchTerm, ...rest } = this.props;

		const { data, loading } = this.getFilteredData();

		return <Field name={name} component={DropdownList}
			options={data} valueField='id' textField='fullName'
			filter busy={loading} clearable
			itemComponent={this.renderListItem}
			valueComponent={this.renderSelectedItem}
			onChange={this.handleSelectChange}
			onSearch={this.handleSearchTermChange}
			{...rest}
		/>;
	}
}

const mapStateToProps = (state) => {
	const { filters, entities: { parents } } = state;

	return {
		parents,
		parentsBySearchTerm: filters.parentsBySearchTerm
	};
};

ParentsDropdownList.propTypes = {
	name: PropTypes.string,
	onChange: PropTypes.func
};

export default connect(mapStateToProps, {
	loadParents,
	fetchParent
})(ParentsDropdownList);